<template>
  <el-submenu
    v-if="hasPermission('feature_group:merchandise')"
    index="/merchandise">
    <template slot="title">
      <div @click="$emit('click')">
        <navigation-icon
          name="merchandise"/>
        Merchandise
      </div>
    </template>
    <!--
      Required for Element to register
      submenu as active. Does not display.
     -->
    <el-menu-item
      v-show="false"
      class="side-navigator__menu-item"
      index="/merchandise">
      Merchandise
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:merchandise:stores')"
      class="side-navigator__menu-item"
      index="/merchandise/stores">
      Stores
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:merchandise:retailers')"
      class="side-navigator__menu-item"
      index="/merchandise/retailers">
      Retailers
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:merchandise:products')"
      class="side-navigator__menu-item"
      index="/merchandise/products">
      Products
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:stockcheck:planograms')"
      class="side-navigator__menu-item"
      index="/pogs">
      Planograms
    </el-menu-item>
    <el-menu-item
      v-if="hasPermission('feature:stockcheck:audits')"
      class="side-navigator__menu-item"
      index="/audits">
      Audits
    </el-menu-item>
  </el-submenu>
</template>

<script>
import NavigationIcon from './NavigationIcon'

export default {
  name: 'MerchandiseNavigationGroup',
  components: {
    NavigationIcon,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/MerchandiseNavigationGroup.vue